<template>
    <div>
        <table class="table table-sm table-hover">
            <tbody>
            <tr>
                <th>Order selling price</th>
                <td>
                    {{ autobookerRun.finance.order_price_currency }} {{ autobookerRun.finance.order_price }}
                </td>
            </tr>
            <tr>
                <th>Budget</th>
                <td>EUR {{ autobookerRun.finance.budget }}</td>
            </tr>
            <tr>
                <th>Expected cost</th>
                <td v-if="autobookerRun.finance.cost_expected !== null">EUR {{
                        autobookerRun.finance.cost_expected
                    }}
                </td>
                <td v-else class="text-muted">Not available</td>
            </tr>
            <tr>
                <th>Expected margin</th>
                <td v-if="autobookerRun.finance.margin_expected !== null">EUR
                    {{ autobookerRun.finance.margin_expected }}
                    <span class="text-muted" v-if="autobookerRun.finance.order_price_currency !== 'EUR'"><br>(Warning: calculated with live exchange rate)</span>
                </td>
                <td v-else class="text-muted">Not available</td>
            </tr>
            </tbody>
        </table>

        <table class="table table-sm table-hover">
            <tbody>
            <tr>
                <th>Real cost</th>
                <td><span v-if="isFinished">EUR {{ autobookerRun.finance.cost_real }}</span><span v-else
                                                                                                  class="text-muted">Waiting for completion</span>
                </td>
            </tr>
            <tr>
                <th>Real margin</th>
                <td>
                <span v-if="isFinished">
                    EUR {{ autobookerRun.finance.margin_real }}
                    <span class="text-muted" v-if="autobookerRun.finance.order_price_currency !== 'EUR'"><br>(Warning: calculated with live exchange rate)</span>
                </span>
                    <span v-else class="text-muted">Waiting for completion</span></td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    name: "AutobookerFinance",

    props: {
        autobookerRun: {
            type: Object,
            required: true
        }
    },

    computed: {
        isFinished() {
            return this.autobookerRun.status === 'SUCCESS';
        }
    }
};
</script>

<style scoped>

</style>
